module.exports = {
  BASE_URL: 'https://api.borigenbetzel.com.ar/api' // Hosting Firebase
  //BASE_URL: 'http://10.0.0.17/api'                 // Servidor Ubuntu
  //BASE_URL: 'http://localhost:443/api'            // Desarrollo (el puerto puede variar)
  //BASE_URL: 'http://10.0.0.181:443/api'
}